import {useEffect, useState} from 'react';
import React, { Component }  from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import "../page-structure/css/popup.css";
import Form from "react-bootstrap/Form";

function SectionsConfigurationModal(props) {

    const [draggedItem, setDraggedItem] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);
    const [fixedSections, setFixedSections] = useState([]);
    const [containerHeight, setContainerHeight] = useState('700px');

    useEffect(() => {
        if (props.sections) {
            setFixedSections(props.sections);
        }
    }, [props.sections, props.settings]);

    useEffect(() => {
        const calculateContainerHeight = () => {
            const viewportHeight = window.innerHeight;
            const modalHeaderHeight = 60; // Approximate header height
            const modalFooterHeight = 60; // Approximate footer height
            const padding = 80; // Padding and margins
            const titleHeight = 40; // Title height
            
            const availableHeight = viewportHeight - modalHeaderHeight - modalFooterHeight - padding - titleHeight;
            const maxHeight = Math.max(300, Math.min(availableHeight, 800)); // Min 300px, Max 800px
            
            setContainerHeight(`${maxHeight}px`);
        };

        calculateContainerHeight();
        window.addEventListener('resize', calculateContainerHeight);
        
        return () => {
            window.removeEventListener('resize', calculateContainerHeight);
        };
    }, []);

    const handleDragStart = (e, index) => {
        setDraggedItem(index);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', e.target.outerHTML);
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        setDragOverIndex(index);
    };

    const handleDragLeave = (e) => {
        // Only clear if we're leaving the drop zone entirely
        if (!e.currentTarget.contains(e.relatedTarget)) {
            setDragOverIndex(null);
        }
    };

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();
        if (draggedItem === null) return;

        const draggedSection = fixedSections[draggedItem];

        // Remove the dragged item
        fixedSections.splice(draggedItem, 1);
        // Insert at the new position
        fixedSections.splice(dropIndex, 0, draggedSection);

        //setSections(newSections);
        setDraggedItem(null);
        setDragOverIndex(null);

        processUpdateSettings();
    };

    const processUpdateSettings = () => {

        const sectionSettings = props.settings.sectionSettings || {};

        fixedSections.forEach((section, index) => {
            const title = section.title;
            if (!sectionSettings[title]) {
                sectionSettings[title] = {};
            }
            sectionSettings[title].order = (index + 1);
        });

        props.settings.sectionSettings = sectionSettings;
        props.setSettings(props.settings);
    }

    const handleDragEnd = () => {
        setDraggedItem(null);
        setDragOverIndex(null);
    };

    const getSectionStyle = (index) => {
        const baseStyle = {
            backgroundColor: '#343a40',
            width: '100%',
            padding: '15px',
            marginBottom: '10px',
            borderRadius: '5px',
            cursor: 'grab',
            border: '1px solid #495057',
            transition: 'all 0.2s ease',
            position: 'relative'
        };

        // If this is the dragged item
        if (draggedItem === index) {
            return {
                ...baseStyle,
                opacity: 0.5,
                border: '2px solid #007bff',
                transform: 'rotate(5deg)',
                boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
            };
        }

        // If this is the drop target
        if (dragOverIndex === index && draggedItem !== null) {
            return {
                ...baseStyle,
                border: '2px dashed #28a745',
                backgroundColor: '#495057',
                transform: 'scale(1.02)',
                boxShadow: '0 2px 8px rgba(40, 167, 69, 0.3)'
            };
        }

        return baseStyle;
    };

    const closeModal = () => {
        props.onHide();
    }

    return (fixedSections && (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName="custom-modal-width custom-modal-height">
            <Modal.Body className="bg-dark d-flex align-items-center justify-content-center w-100 row details">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                    <div className="pt-2 pb-2">
                        <Form className="pt-2 pb-2">

                            <h2 className={"text-left pb-2"}>Settings Configuration</h2>

                                                         <div 
                                 className="sections-container" 
                                 style={{ overflowY: 'auto', maxHeight: containerHeight }}
                                 onDragLeave={handleDragLeave}
                             >
                                {fixedSections.map((section, index) => (
                                    <div
                                        key={section.id}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, index)}
                                        onDragOver={(e) => handleDragOver(e, index)}
                                        onDrop={(e) => handleDrop(e, index)}
                                        onDragEnd={handleDragEnd}
                                        style={getSectionStyle(index)}
                                        onMouseDown={(e) => e.target.style.cursor = 'grabbing'}
                                        onMouseUp={(e) => e.target.style.cursor = 'grab'}
                                    >
                                        <div style={{ color: 'white', fontWeight: 'bold', fontSize: '24px', textAlign: 'center' }}>
                                            {section.title}
                                        </div>
                                        {dragOverIndex === index && draggedItem !== null && (
                                            <div style={{
                                                position: 'absolute',
                                                bottom: '-5px',
                                                left: '0',
                                                right: '0',
                                                height: '3px',
                                                backgroundColor: '#28a745',
                                                borderRadius: '2px'
                                            }}></div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </Form>
                    </div>
                </div>
                <div className="col-md-3"></div>
            </Modal.Body>
            <Modal.Footer className="bg-dark">
                <Button onClick={closeModal}>Close</Button>
            </Modal.Footer>
        </Modal>
    ));
}

export default SectionsConfigurationModal;